
import req from './request'

const DEFAULT_ENDPOINTS = {
    default: '/ie',
    reference: '/ie/reference',
    drivers: '/ie/drivers',
    driversView: '/ie/drivers/view',
    driversEvents: '/ie/drivers/events',
    driversDocuments: '/ie/drivers/documents',
    driversSummaryReport: '/ie/drivers/summary-report',
    documentsAuth: '/ie/documents/auth',
    documents: '/ie/documents',
    archive: '/ie/documents/archive',
    signDocuments:'/ie/documents/sign-documents',
    generateContract: '/ie/drivers/generate-contract',
    summary: '/ie/summary',
    paydaDocuments: '/ie/payda-documents',
    paydaSignPercent: '/ie/payda-sign-percent',
    agreementStatistics: '/ie/agreement-statistic',
    useSettings: '/dashboard/ie/use-settings',
    blockDay: '/dashboard/ie/block-day',
    blockProcessing: '/ie/block-processing',

    sapar: '/ie/documents/sapar',
    payda: '/ie/documents/payda',

    // old
    candidates: '/ie/candidates',
    view: '/ie/candidates/view',
    balances: '/ie/candidates/balances',
    //reference: '/ie/candidates/reference',
    parks: '/ie/default/parks',
    defaultView: '/ie/default/view',
    defaultReference: '/ie/default/reference',
    defaultApprove: '/ie/default/approve',
    defaultDecline: '/ie/default/decline',
    defaultArchive: '/ie/default/archive',
    archivePark: '/ie/archive/park',
    archiveBtl: '/ie/archive/back-to-list',
    archiveReference: '/ie/archive/reference',
    dismissals: '/ie/dismissals',
    sigex: '/ie/sigex',
    paydaparks: '/dashboard/ie/payda/parks',
    blockOnOoff: '/dashboard/ie/block-on-off',
    getLink: '/ie/get-link'
    
}

export default {
    default(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.default, param)
    },
    reference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    drivers(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.drivers, param)
    },
    driversView(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversView, param)
    },
    driversEvents(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversEvents, param)
    },
    driversDocuments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversDocuments, param)
    },
    driversSummaryReport(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversSummaryReport, param)
    },
    documentsAuth(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.documentsAuth, param)
    },
    documents(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.documents, param)
    },
    archive(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.archive, param)
    },
    signDocuments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.signDocuments, param)
    },
    sigex(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sigex, param)
    },
    summary(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.summary, param)
    },

    paydaparks(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paydaparks, param)
    },
    paydaDocuments(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paydaDocuments, param)
    },
    paydaSignPercent(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paydaSignPercent, param)
    },
    agreementStatistics(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementStatistics, param)
    },
    useSettings(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.useSettings, param)
    },
    blockOnOoff(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.blockOnOoff, param)
    },
    blockDay(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.blockDay, param)
    },
    blockProcessing(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.blockProcessing, param)
    },
    getLink(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getLink, param)
    },
    sapar(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sapar, param)
    },
    payda(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.payda, param)
    },
    

    // old

    candidates(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.candidates, param)
    },
    view(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.view, param)
    },
    balances(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.balances, param)
    },
    parks(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parks, param)
    },
    defaultView(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultView, param)
    },
    defaultReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultReference, param)
    },
    defaultApprove(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultApprove, param)
    },
    defaultDecline(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultDecline, param)
    },
    defaultArchive(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultArchive, param)
    },
  
    archivePark(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.archivePark, param)
    },
    archiveBtl(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.archiveBtl, param)
    },
    archiveReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.archiveReference, param)
    },
    default(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.default, param)
    },
    dismissals(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.dismissals, param)
    },
    generateContract(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.generateContract, param)
    },
    

}